<script setup lang="ts">
import useEventStore from "~/stores/event";

export interface EventTagsFooter {
  tagsIds: string[];
  canShowActionButton: boolean;
}

const { t } = useI18n();
const emit = defineEmits(["delete"]);
const eventStore = useEventStore();
const props = defineProps<EventTagsFooter>();

const hasPlayerError = computed(() => eventStore.playerState?.error !== null);

const createTag = () => {
  eventStore.tags.isCreatingTag = true;
  eventStore.clips.isCreatingClip = false;
};
</script>

<template>
  <template v-if="props.canShowActionButton">
    <div class="absolute bottom-0 flex w-full justify-center gap-2 dark:bg-[var(--base-popup-bgColor)] py-6 px-4">
      <BaseButton
        :title="t('button.delete')"
        name="delete-button"
        type="secondary"
        class="w-1/2 text-button-bold text-main"
        @click="emit('delete', props.tagsIds)"
      >
        <div class="flex items-center justify-center gap-2 truncate">
          <IconDelete fill="var(--base-error-color)" />
          {{ t('button.delete') }}
        </div>
      </BaseButton>
      <!-- Will be implemented in future, with "Creating highlight" functionality -->
      <!-- <BaseButton
        type="primary"
        name="create-highlight"
        :title="t('labels.create_highlight')"
        class="w-1/2 text-button-bold text-main"
      >
        <div class="flex items-center justify-center truncate">
          <IconHighlight :width="16" :height="16" fill="#ffffff" class="flex-shrink-0 mx-2" />
          {{ t("labels.create_highlight") }}
        </div>
      </BaseButton> -->
    </div>
  </template>
  <template v-else>
    <div class="absolute bottom-0 flex w-full justify-center gap-2 py-6 px-4 dark:bg-gradient-to-t from-[#000000]/40">
      <BaseButton
        type="primary"
        name="create-tag"
        :disabled="hasPlayerError"
        :title="t('pages.events.tabs.event_tags.create_tag')"
        class="w-1/2 text-button-bold text-main"
        @click="createTag"
      >
        <div class="flex items-center justify-center truncate">
          <IconTag
            :width="16"
            :height="16"
            fill="#ffffff"
            class="flex-shrink-0 mx-2"
          />
          {{ t("pages.events.tabs.event_tags.create_tag") }}
        </div>
      </BaseButton>
    </div>
  </template>
</template>
